<template>
  <div class="TypeBox">
    <div class="title">
      不同的违规类型，对应扣减的行为分不同。行为分的分值分为3个等级，每个层级受到的处罚严重程度不同，详见上方分数解读。下面为违规类型对应的扣分标准：
    </div>
    <div class="list">
      <div class="listTitle item">
        <div class="left">违规类型</div>
        <div class="right">扣分数值</div>
      </div>
      <div
        class="item"
        v-for="(item, index) in listData"
        :key="index"
        @click="linkToViolationDetail(item.type)"
      >
        <div class="left">
          <span class="status" :class="item.status"></span>
          <span class="text" v-text="item.text"></span>
          <van-icon name="arrow" class="icon" />
        </div>
        <div class="right record" v-text="item.record"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "vant";
export default {
  name: "Type",
  data() {
    return {
      listData: [
        {
          text: "向客服提及违规话语",
          record: "3分",
          type: 2,
          status: "one",
        },
        {
          text: "关键词作弊",
          record: "3分",
          type: 1,
          status: "one",
        },
        {
          text: "评价抄袭",
          record: "3分",
          type: 3,
          status: "one",
        },
        {
          text: "申请发票",
          record: "3分",
          type: 9,
          status: "one",
        },
        {
          text: "使用其他红包优惠",
          record: "3分",
          type: 12,
          status: "one",
        },
        {
          text: "使用淘宝客",
          record: "3分/取消订单处理",
          type: 0,
          status: "one",
        },
        {
          text: "负面评价",
          record: "6分",
          type: 5,
          status: "two",
        },
        {
          text: "违反平台规则",
          record: "6分",
          type: 4,
          status: "two",
        },
        {
          text: "投诉商家",
          record: "6分",
          type: 10,
          status: "two",
        },
        {
          text: "退款不退还返利",
          record: "12分",
          type: 6,
          status: "three",
        },
        {
          text: "管理员临时限制",
          record: "视违规情况而定",
          type: 11,
          status: "four",
        },
        {
          text: "平台风险控制",
          record: "对账号进行限制",
          type: 7,
          status: "four",
        },
      ],
    };
  },
  components: {
    "van-icon": Icon,
  },
  methods: {
    linkToViolationDetail(type) {
      this.$router.push({
        name: "violationDetail",
        query: {
          type: type,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.TypeBox {
  .title {
    font-size: 14px;
    background-color: #f0f0f2;
    padding: 11px 19px;
    color: #999999;
  }
  .list {
    padding: 18px 19px;
    background-color: #fff;
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 26px;
      &:last-child {
        margin-bottom: 0;
      }
      .left {
        display: flex;
        align-items: center;
        .text {
          font-size: 15px;
        }
        .status {
          width: 8px;
          height: 8px;
          background-color: #77bdf0;
          border-radius: 50%;
          margin-right: 10px;
        }
        .status.one {
          background-color: #77bdf0;
        }
        .status.two {
          background-color: #faac41;
        }
        .status.three {
          background-color: #f22c2c;
        }
        .status.four {
          background-color: #bbbbbb;
        }
        .icon {
          color: #cdcdda;
          margin-left: 4px;
          font-size: 16px;
        }
      }
    }
    .listTitle {
      font-weight: 700;
      font-size: 15px;
    }
  }
}
</style>
